import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TableSortLabel,
  Button,
} from '@mui/material';
import PropTypes from 'prop-types';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

function RoomManagerTable({ records, onDelete, logOutRoom, genrateLogInCode }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [orderDirection, setOrderDirection] = useState('asc');
  const [orderBy, setOrderBy] = useState('residentName');

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && orderDirection === 'asc';
    setOrderDirection(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const sortedRecords = () => {
    return records.sort((a, b) => {
      let aValue = a[orderBy];
      let bValue = b[orderBy];

      if (aValue < bValue) {
        return orderDirection === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return orderDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer component={Paper}>
      <Table aria-label="devices table">
        <TableHead>
          <TableRow>
            <TableCell key="edit"></TableCell>

            <TableCell key="roomName">
              <TableSortLabel
                active={orderBy === 'roomName'}
                direction={orderBy === 'roomName' ? orderDirection : 'asc'}
                onClick={() => handleRequestSort('roomName')}
              >
                Room Name
              </TableSortLabel>
            </TableCell>
            <TableCell key="groupName">
              <TableSortLabel
                active={orderBy === 'groupName'}
                direction={orderBy === 'groupName' ? orderDirection : 'asc'}
                onClick={() => handleRequestSort('groupName')}
              >
                Group Name
              </TableSortLabel>
            </TableCell>
            <TableCell key="logedInCode">
              <TableSortLabel>Logged In Code</TableSortLabel>
            </TableCell>
            <TableCell key="genrateLogInCode"></TableCell>
            <TableCell key="status">
              <TableSortLabel
                active={orderBy === 'status'}
                direction={orderBy === 'status' ? orderDirection : 'asc'}
                onClick={() => handleRequestSort('status')}
              >
                Status
              </TableSortLabel>
            </TableCell>
            <TableCell key="logOut"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedRecords()
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((record) => (
              <TableRow key={record.id}>
                <TableCell>
                  <div style={{ display: 'inline-flex' }}>
                    <DeleteForeverIcon
                      onClick={() => onDelete(record)}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                </TableCell>

                <TableCell component="th" scope="row">
                  {record.roomName}
                </TableCell>
                <TableCell component="th" scope="row">
                  {record.groupName}
                </TableCell>
                <TableCell component="th" scope="row">
                  {record.logInCode}
                </TableCell>
                <TableCell component="th" scope="row">
                  <Button
                    variant="contained"
                    onClick={() => genrateLogInCode(record.id)}
                  >
                    Generate Code
                  </Button>
                </TableCell>

                <TableCell component="th" scope="row">
                  {record.logedIn ? 'Logged In' : 'Logged Out'}
                </TableCell>
                <TableCell component="th" scope="row">
                  <button
                    className="signoutButton"
                    style={{
                      width: '30px',
                      border: 'none',
                      backgroundColor: 'transparent',
                    }}
                    onClick={() => logOutRoom(record.id)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 192 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z" />
                    </svg>
                  </button>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={records.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
}

RoomManagerTable.propTypes = {
  records: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      roomName: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onDelete: PropTypes.func.isRequired,
  logOutRoom: PropTypes.func.isRequired,
  genrateLogInCode: PropTypes.func.isRequired,
};

export default RoomManagerTable;
